import { createClient } from '@supabase/supabase-js';

// Эти значения нужно будет заменить на реальные из Supabase проекта
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Типы для таблиц
export interface Database {
  public: {
    Tables: {
      keys: {
        Row: {
          id: number;
          key: string;
          name: string | null;
          used: boolean;
          created_at: string;
          used_at: string | null;
          used_by: string | null;
        };
        Insert: {
          id?: number;
          key: string;
          name?: string | null;
          used?: boolean;
          created_at?: string;
          used_at?: string | null;
          used_by?: string | null;
        };
        Update: {
          id?: number;
          key?: string;
          name?: string | null;
          used?: boolean;
          created_at?: string;
          used_at?: string | null;
          used_by?: string | null;
        };
      };
      rsvp_responses: {
        Row: {
          id: number;
          name: string;
          will_attend: boolean;
          day1: boolean;
          day2: boolean;
          overnight: string;
          comment: string | null;
          secret_key: string;
          created_at: string;
        };
        Insert: {
          id?: number;
          name: string;
          will_attend: boolean;
          day1: boolean;
          day2: boolean;
          overnight: string;
          comment?: string | null;
          secret_key: string;
          created_at?: string;
        };
        Update: {
          id?: number;
          name?: string;
          will_attend?: boolean;
          day1?: boolean;
          day2?: boolean;
          overnight?: string;
          comment?: string | null;
          secret_key?: string;
          created_at?: string;
        };
      };
      wishlist: {
        Row: {
          id: string;
          name: string;
          link: string | null;
          reserved_by: string | null;
          secret_key: string | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          link?: string | null;
          reserved_by?: string | null;
          secret_key?: string | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          link?: string | null;
          reserved_by?: string | null;
          secret_key?: string | null;
          created_at?: string;
        };
      };
      guestbook: {
        Row: {
          id: number;
          author: string;
          message: string;
          created_at: string;
        };
        Insert: {
          id?: number;
          author: string;
          message: string;
          created_at?: string;
        };
        Update: {
          id?: number;
          author?: string;
          message?: string;
          created_at?: string;
        };
      };
    };
  };
} 